import Link from "next/link";
import Image from "next/image";
import {
  FaFacebook,
  FaInstagram,
  FaYoutube,
  FaWhatsapp,
} from "react-icons/fa";
import { SiTiktok } from "react-icons/si";

const whatsappNumber = process.env.NEXT_PUBLIC_WHATSAPPNUMBER;

export default function Footer() {
  return (
    <footer className="bg-yellow-50 border-t border-gray-300 pt-12 pb-8 text-gray-700 text-sm">
      <div className="container mx-auto px-6">

        {/* ✅ Top Grid: Adjusted for mobile centering */}
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-10">
          
          {/* ✅ Brand + Social Icons */}
          <div className="text-center sm:text-left">
            <Image
              src="/images/logo-1.png"
              alt="SRKTRENDS"
              width={100}
              height={100}
              className="mb-2 mx-auto sm:mx-0"
            />
            <p className="mb-3 font-semibold">Let’s Get You Styled</p>
            <div className="flex justify-center sm:justify-start gap-4 text-xl">
              <a href="https://facebook.com" target="_blank" rel="noopener noreferrer" className="text-[#1877F2] hover:text-[#165db0] transition"><FaFacebook /></a>
              <a href="https://instagram.com" target="_blank" rel="noopener noreferrer" className="text-[#E4405F] hover:text-[#c22d4c] transition"><FaInstagram /></a>
              <a href="https://youtube.com" target="_blank" rel="noopener noreferrer" className="text-[#FF0000] hover:text-[#cc0000] transition"><FaYoutube /></a>
              <a href={`https://wa.me/${whatsappNumber}`} target="_blank" rel="noopener noreferrer" className="text-[#25D366] hover:text-[#1aa34a] transition"><FaWhatsapp /></a>
              <a href="https://www.tiktok.com/@nawazmohammed37" target="_blank" rel="noopener noreferrer" className="text-black hover:text-green-600 transition"><SiTiktok /></a>
            </div>
          </div>

          {/* ✅ Womenswear */}
          <div className="text-center sm:text-left">
            <p className="font-semibold mb-3">Womenswear</p>
            <ul className="space-y-1">
              {["Saree", "Lehenga", "Gown", "Gharara"].map((item) => (
                <li key={item}>
                  <Link href="/womens" className="hover:underline">{item}</Link>
                </li>
              ))}
            </ul>
          </div>

          {/* ✅ Menswear */}
          <div className="text-center sm:text-left">
            <p className="font-semibold mb-3">Menswear</p>
            <ul className="space-y-1">
              {["Sherwani", "Blazer", "Shoes"].map((item) => (
                <li key={item}>
                  <Link href="/mens" className="hover:underline">{item}</Link>
                </li>
              ))}
            </ul>
          </div>

          {/* ✅ Useful Links */}
          <div className="text-center sm:text-left">
            <p className="font-semibold mb-3">Useful Links</p>
            <ul className="space-y-1">
              <li><Link href="/about" className="hover:underline">About Us</Link></li>
              <li><Link href="/book-app" className="hover:underline">Book Appointment</Link></li>
              <li><Link href="/contact" className="hover:underline">Contact Us</Link></li>
            </ul>
          </div>
        </div>

        {/* ✅ Bottom Divider Section */}
        <div className="border-t border-gray-300 mt-10 pt-6 text-center text-sm">
          <p className="mb-1">&copy; {new Date().getFullYear()} SRKTrends. All rights reserved.</p>
          <p className="text-gray-500">
            Powered by{" "}
            <a href="https://tesose.com/" className="text-blue-500 hover:underline">TESose Infotech</a>
          </p>

          <div className="mt-3 flex flex-wrap justify-center gap-x-4 gap-y-2 text-gray-600">
            <Link href="/terms-of-use" className="hover:underline">Terms</Link>
            <Link href="/privacy-policy" className="hover:underline">Privacy Policy</Link>
            <Link href="/cookie-policy" className="hover:underline">Cookie Policy</Link>
            <Link href="/policy-disclaimer" className="hover:underline">Disclaimer Policy</Link>
          </div>
        </div>
      </div>
    </footer>
  );
}